import { render, staticRenderFns } from "./PublicNavMenuLink.vue?vue&type=template&id=319534b2&"
import script from "./PublicNavMenuLink.vue?vue&type=script&lang=js&"
export * from "./PublicNavMenuLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports